<template>
  <t-main-container :menuName="menuName" :menuList="menuList">
    <router-view />
  </t-main-container>
</template>

<script>
import { TMainContainer } from "@/components/layout";
import { menuName, menuList } from "@/constant/views/dashboard/devops/backup";
export default {
  components: {
    [TMainContainer.name]: TMainContainer
  },
  setup() {
    return {
      menuName,
      menuList
    };
  }
};
</script>
